/**
 * 基于 File System Access API 的本地资源选择。
 * 仅 Chromium 系浏览器支持；不支持时抛出明确错误。
 */

export function isFileSystemAccessSupported() {
  return typeof window.showOpenFilePicker === 'function' &&
      typeof window.showDirectoryPicker === 'function';
}

function assertSupported() {
  if (!isFileSystemAccessSupported()) {
    throw new Error(
        '当前浏览器不支持 File System Access API，请使用 Chrome / Edge');
  }
}

/** 选择本地图片文件，返回 File */
export async function pickImageFile() {
  assertSupported();
  const [handle] = await window.showOpenFilePicker({
    multiple: false,
    types: [{
      description: '图片',
      accept: {
        'image/*': ['.png', '.jpg', '.jpeg', '.webp', '.gif', '.bmp'],
      },
    }],
  });
  return handle.getFile();
}

/** 选择本地视频文件，返回 File */
export async function pickVideoFile() {
  assertSupported();
  const [handle] = await window.showOpenFilePicker({
    multiple: false,
    types: [{
      description: '视频',
      accept: {
        'video/*': ['.mp4', '.webm', '.mov', '.mkv'],
      },
    }],
  });
  return handle.getFile();
}

/**
 * 选择皮影根文件夹。
 * 约定：根目录下有数字子文件夹 01/02/03…，其内为皮影 png。
 * @return {Promise<Array<{id: string, files: File[]}>>}
 */
export async function pickPiyingDirectory() {
  assertSupported();
  const root = await window.showDirectoryPicker({mode: 'read'});
  const packs = [];

  for await (const [name, handle] of root.entries()) {
    if (handle.kind !== 'directory' || !/^\d+$/.test(name)) {
      continue;
    }
    const files = [];
    for await (const [fileName, fileHandle] of handle.entries()) {
      if (fileHandle.kind !== 'file') {
        continue;
      }
      if (!/\.(png|jpe?g|webp)$/i.test(fileName)) {
        continue;
      }
      files.push(await fileHandle.getFile());
    }
    if (files.length > 0) {
      packs.push({id: name, files});
    }
  }

  packs.sort((a, b) => parseInt(a.id, 10) - parseInt(b.id, 10));
  if (packs.length === 0) {
    throw new Error(
        '未找到有效皮影套装：请选择包含 01/02/03… 子文件夹的目录');
  }
  return packs;
}
